import { PublicationStatus, type PublicationDto, type PublicationFailureDto } from "../../../autogen/bff-api";

export type SchemeEnding =
  | { state: "none" }
  | { state: "pending" }
  | { state: "refused"; failure?: PublicationFailureDto | null };

export const schemeEnding = (publications: PublicationDto[] = []): SchemeEnding => {
  const latest = publications.filter((publication) => publication.endsQualificationScheme).at(-1);
  if (!latest || latest.status === PublicationStatus.Published) return { state: "none" };
  if (latest.status === PublicationStatus.Failed) return { state: "refused", failure: latest.failure };
  return { state: "pending" };
};
